import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Types ───

export interface AppointmentCategoryRow {
  id: string;
  org_id: string | null;
  clinic_id: string | null;
  name: string | null;
  description: string | null;
  color_hex: string | null;
  typical_duration_mins: number | null;
  active: number | null; // 0/1
  sort_order: number | null;
  created_at: string | null;
  updated_at: string | null;
}

// ─── Queries ───

/**
 * Fetch all appointment categories, ordered by sort_order.
 */
export function qAppointmentCategories(): QuerySpec<[]> {
  return {
    key: ['appointment-categories'] as const,
    sql: `SELECT * FROM appointment_categories ORDER BY sort_order ASC, name ASC`,
    params: [],
    watch: ['appointment_categories'],
  };
}

// ─── Helpers ───

export function mapCategoryRowToUI(row: AppointmentCategoryRow) {
  return {
    id: row.id,
    name: row.name ?? '',
    description: row.description ?? '',
    color: row.color_hex ?? '#3b82f6',
    typicalDuration: row.typical_duration_mins,
    active: row.active === 1,
    sortOrder: row.sort_order ?? 0,
  };
}

export function mapUIToCategoryColumns(ui: {
  name: string;
  description: string;
  color: string;
  typicalDuration: number | null;
  active: boolean;
  sortOrder: number;
}) {
  return {
    name: ui.name,
    description: ui.description || null,
    color_hex: ui.color,
    typical_duration_mins: ui.typicalDuration,
    active: ui.active ? 1 : 0,
    sort_order: ui.sortOrder,
    updated_at: new Date().toISOString(),
  };
}
